import React, { useEffect, useRef, useState } from 'react';
import { renderBarcode } from '../utils/barcode';
import { fmtMoney } from '../utils/format';

// Printable barcode label for a single product. Renders a clean A6-ish
// card with the shop name, product name, SKU, price and the barcode itself.
// Designed to be triggered with window.print() — the @media print rule in
// pos.css hides everything else.
const BarcodeLabel = ({ product, facility, copies = 1 }) => {
  const svgRefs = useRef([]);
  const [renderError, setRenderError] = useState(false);

  useEffect(() => {
    setRenderError(false);
    const data = product?.barcode || product?.sku;
    if (!data) { setRenderError(true); return; }
    svgRefs.current.forEach((el) => {
      try {
        renderBarcode(el, data, { width: 2, height: 60, fontSize: 14 });
      } catch (_) { setRenderError(true); }
    });
  }, [product, copies]);

  if (!product) return null;

  if (renderError) {
    return (
      <div className="notice">
        This product has no barcode or SKU to render. Add or generate a barcode first.
      </div>
    );
  }

  return (
    <div className="label-sheet">
      {Array.from({ length: copies }).map((_, i) => (
        <div className="label-card" key={i}>
          {facility?.name && <div className="label-shop">{facility.name}</div>}
          <div className="label-name">{product.name}</div>
          <svg ref={(el) => { svgRefs.current[i] = el; }} className="label-barcode" />
          <div className="label-foot">
            <span className="label-sku">{product.sku}</span>
            {product.selling_price != null && (
              <span className="label-price">{fmtMoney(product.selling_price)}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BarcodeLabel;
